export default __webpack_public_path__ + "static/media/text_banner.97e1d6be.png";